import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { api, setToken } from "./api";

export const LoginForm = ({ onSuccess, autoFocus = false }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await api("/auth/login", {
        method: "POST",
        auth: false,
        body: { email, password },
      });
      setToken(data.token);
      onSuccess(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={onSubmit} data-testid="admin-login-form">
      <div className="space-y-4">
        <div>
          <label htmlFor="admin-email" className="block text-sm font-semibold text-ink">
            Username
          </label>
          <input
            id="admin-email"
            type="text"
            autoComplete="username"
            autoFocus={autoFocus}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 block w-full min-h-[48px] rounded-lg border border-sage/25 px-4 py-3 text-base text-ink focus:border-sage focus:outline-none focus:ring-2 focus:ring-sage-light/40"
            data-testid="admin-login-email-input"
          />
        </div>
        <div>
          <label htmlFor="admin-password" className="block text-sm font-semibold text-ink">
            Password
          </label>
          <div className="relative mt-1.5">
            <input
              id="admin-password"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full min-h-[48px] rounded-lg border border-sage/25 px-4 py-3 pr-12 text-base text-ink focus:border-sage focus:outline-none focus:ring-2 focus:ring-sage-light/40"
              data-testid="admin-login-password-input"
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              aria-pressed={showPassword}
              className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-2 text-sage transition-colors hover:bg-sage-soft"
              data-testid="admin-login-toggle-password"
            >
              {showPassword ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
            </button>
          </div>
        </div>
      </div>
      {error && (
        <p role="alert" className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-800" data-testid="admin-login-error">
          {error}
        </p>
      )}
      <button
        type="submit"
        disabled={busy}
        className="mt-6 inline-flex min-h-[48px] w-full items-center justify-center rounded-full bg-sage px-8 py-3 text-sm font-semibold text-cream transition-colors hover:bg-sage-light disabled:opacity-60"
        data-testid="admin-login-submit-button"
      >
        {busy ? "Signing in…" : "Sign in"}
      </button>
    </form>
  );
};
